import Rx from 'rxjs';

export default class PermissionsService {
    constructor($http, host) {
        this.http = $http;
        this.host = host;
    }

    getPermissions() {
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: `${this.host}/api/permissions`
        }).then(
            resp => resp.data.permissions,
            resp => resp
        ));
    }

}

PermissionsService.$inject = ['$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/permissions.service.js